import Point3D from "../math/Point3D";
import C_Ships from "../../const/C_Ships";

class FlierData
{

    constructor()
    {
        this.byType =
        {
            // 1:
            // {
            //     shipType: C_Ships.ENEMY_SHIP,
            //     size:4,
            //     health:20,
            //     qtyMin:2,
            //     qtyMax:5,
            //     movement: "3d",
            //     vel3DMin:{x:0, y:0, z:40},
            //     vel3DMax:{x:0, y:0, z:100},
            //     spawnDelay:2,
            //     multiplierChance: 0.01,
            //     shootChance:.1,
            //     shootOrigins:[{x:-44, y:30}, {x:44, y:30}],
            //     shootDelay: 0,
            //     serverId:4,
            //     posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
            //     posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            // },
            //
            // 2:
            // {
            //     shipType: C_Ships.ENEMY_SHIP,
            //     size:7,
            //     health:40,
            //     qtyMin:1,
            //     qtyMax:4,
            //     movement: "3d",
            //     vel3DMin:{x:0, y:0, z:30},
            //     vel3DMax:{x:0, y:0, z:40},
            //     spawnDelay:3,
            //     multiplierChance: 0.01,
            //     shootChance:.2,
            //     shootOrigins:[{x:0, y:22}],
            //     shootDelay: 0,
            //     serverId:7,
            //     posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
            //     posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            // },
            //
            // 3:
            // {
            //     shipType: C_Ships.ENEMY_SHIP,
            //     size:8,
            //     health:200,
            //     qtyMin:1,
            //     qtyMax:2,
            //     movement: "3d",
            //     vel3DMin:{x:0, y:0, z:20},
            //     vel3DMax:{x:0, y:0, z:30},
            //     spawnDelay:4,
            //     multiplierChance: 0.01,
            //     shootChance:.3,
            //     shootOrigins:[{x:0, y:-45}],
            //     shootDelay: 0,
            //     serverId:10,
            //     posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
            //     posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            // },
            //
            // 4:
            // {
            //     shipType: C_Ships.ENEMY_SHIP,
            //     size:16,
            //     health:500,
            //     qtyMin:1,
            //     qtyMax:1,
            //     movement: "3d",
            //     vel3DMin:{x:0, y:0, z:10},
            //     vel3DMax:{x:0, y:0, z:20},
            //     spawnDelay:5,
            //     multiplierChance: 0.01,
            //     shootChance:.4,
            //     shootOrigins:[{x:-38, y:41},{x:-26, y:41},{x:26, y:41},{x:38, y:41}],
            //     shootDelay: 0,
            //     serverId:11,
            //     posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
            //     posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            // },

            1:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:7,
                health:20,
                qtyMin:2,
                qtyMax:5,
                movement: "2d",
                velMin: 6,
                velMax: 7,
                vel3DMin:{x:0, y:0, z:40},
                vel3DMax:{x:0, y:0, z:100},
                spawnDelay:2,
                multiplierChance: 0.01,
                shootChance:.1,
                shootOrigins:[{x:-44, y:30}, {x:44, y:30}],
                shootDelay: 0,
                prize: 20,
                serverId:4,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            2:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:10,
                health:40,
                qtyMin:2,
                qtyMax:4,
                velMin: 5.5,
                velMax: 6,
                movement: "2d",
                vel3DMin:{x:0, y:0, z:30},
                vel3DMax:{x:0, y:0, z:40},
                spawnDelay:3,
                multiplierChance: 0.01,
                shootChance:.2,
                shootOrigins:[{x:0, y:22}],
                shootDelay: 0,
                prize: 25,
                serverId:7,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            3:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:12,
                health:200,
                qtyMin:2,
                qtyMax:3,
                movement: "2d",
                velMin: 3.5,
                velMax: 3.5,
                vel3DMin:{x:0, y:0, z:20},
                vel3DMax:{x:0, y:0, z:30},
                spawnDelay:4,
                multiplierChance: 0.01,
                shootChance:.3,
                shootOrigins:[{x:0, y:-45}],
                shootDelay: 0,
                prize: 30,
                serverId:10,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            4:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:16,
                health:500,
                qtyMin:1,
                qtyMax:2,
                movement: "2d",
                velMin: 2.5,
                velMax: 3,
                vel3DMin:{x:0, y:0, z:10},
                vel3DMax:{x:0, y:0, z:20},
                spawnDelay:5,
                multiplierChance: 0.01,
                shootChance:.4,
                shootOrigins:[{x:-38, y:41},{x:-26, y:41},{x:26, y:41},{x:38, y:41}],
                shootDelay: 0,
                prize: 40,
                serverId:11,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            5:
            {
                shipType: C_Ships.ROCK,
                size:5,
                health:100,
                qtyMin:1,
                qtyMax:3,
                movement: "2d",
                velMin: 3,
                velMax: 3,
                vel3DMin:{x:-2, y:2, z:0},
                vel3DMax:{x:2, y:3, z:0},
                spawnDelay:2,
                multiplierChance: 0.01,
                shootChance:0,
                prize: 7,
                serverId:9,
                permanentRotation:true,
                // overlay:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            6:
            {
                shipType: C_Ships.ROCK,
                size:5,
                health:200,
                qtyMin:1,
                qtyMax:3,
                movement: "2d",
                velMin: 3,
                velMax: 4,
                vel3DMin:{x:-2, y:2, z:0},
                vel3DMax:{x:2, y:3, z:0},
                spawnDelay:3,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 8,
                serverId:8,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            7:
            {
                shipType: C_Ships.ROCK,
                size:9,
                health:200,
                qtyMin:1,
                qtyMax:2,
                movement: "2d",
                velMin: 2,
                velMax: 3,
                vel3DMin:{x:-2, y:2, z:0},
                vel3DMax:{x:2, y:3, z:0},
                spawnDelay:4,
                multiplierChance: 0.01,
                rotation:-Math.PI ,
                shootChance:0,
                prize: 10,
                serverId:6,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            8:
            {
                shipType: C_Ships.ROCK,
                size:10,
                health:200,
                qtyMin:1,
                qtyMax:2,
                movement: "2d",
                velMin: 1.5,
                velMax: 2,
                vel3DMin:{x:-2, y:2, z:0},
                vel3DMax:{x:2, y:3, z:0},
                spawnDelay:8,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 12,
                serverId:1,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            9:
            {
                shipType: C_Ships.ROCK,
                size:14,
                health:200,
                qtyMin:1,
                qtyMax:3,
                movement: "2d",
                velMin: 2,
                velMax: 3,
                vel3DMin:{x:2, y:0, z:0},
                vel3DMax:{x:3, y:0, z:0},
                spawnDelay:3,
                multiplierChance: 0.01,
                rotation:-Math.PI ,
                shootChance:0,
                prize: 15,
                serverId:5,
                permanentRotation:true,
                // overlay:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            10:
            {
                shipType: C_Ships.DEBRIS,
                size:6,
                health:200,
                qtyMin:1,
                qtyMax:2,
                movement: "2d",
                velMin: 2,
                velMax: 3,
                vel3DMin:{x:-2, y:2, z:0},
                vel3DMax:{x:2, y:3, z:0},
                spawnDelay:12,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 2,
                serverId:3,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            11:
            {
                shipType: C_Ships.DEBRIS,
                size:6,
                health:200,
                qtyMin:1,
                qtyMax:2,
                movement: "2d",
                velMin: 3,
                velMax: 4,
                vel3DMin:{x:-2, y:2, z:0},
                vel3DMax:{x:2, y:3, z:0},
                spawnDelay:12,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 2,
                serverId:2,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            12:
            {
                shipType: C_Ships.DEBRIS,
                size:6,
                health:200,
                qtyMin:1,
                qtyMax:2,
                movement: "2d",
                velMin: 2,
                velMax: 3,
                vel3DMin:{x:-3, y:2, z:0},
                vel3DMax:{x:3, y:3, z:0},
                spawnDelay:12,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 3,
                serverId:12,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            13:
            {
                shipType: C_Ships.DEBRIS,
                size:7,
                health:200,
                qtyMin:1,
                qtyMax:1,
                movement: "2d",
                velMin: 2.5,
                velMax: 3,
                vel3DMin:{x:-3, y:2, z:0},
                vel3DMax:{x:3, y:3, z:0},
                spawnDelay:8,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 4,
                serverId:13,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            14:
            {
                shipType: C_Ships.DEBRIS,
                size:7,
                health:200,
                qtyMin:1,
                qtyMax:2,
                movement: "2d",
                velMin: 1.5,
                velMax: 2,
                vel3DMin:{x:-3, y:2, z:0},
                vel3DMax:{x:3, y:3, z:0},
                spawnDelay:8,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 5,
                serverId:14,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            15:
            {
                shipType: C_Ships.DEBRIS,
                size:10,
                health:200,
                qtyMin:1,
                qtyMax:1,
                movement: "2d",
                velMin: 2,
                velMax: 3,
                vel3DMin:{x:-1, y:2, z:0},
                vel3DMax:{x:1, y:2, z:0},
                spawnDelay:20,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 6,
                serverId:15,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            16:
            {
                shipType: C_Ships.FLARE,
                size:18,
                health:200,
                qtyMin:1,
                qtyMax:1,
                animation: true,
                endFrame: 9,
                animationHeight: 100,
                animAnchor: {x: 0.5, y: 0.5},
                movement: "2d",
                velMin: 3,
                velMax: 4,
                vel3DMin:{x:-2, y:2, z:0},
                vel3DMax:{x:2, y:3, z:0},
                spawnDelay:15,
                rotation:-Math.PI,
                shootChance:0,
                prize: 200,
                serverId:6,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            17:
            {
                shipType: C_Ships.CRATE,
                size:8,
                health:200,
                qtyMin:1,
                qtyMax:1,
                movement: "2d",
                velMin: 2,
                velMax: 2.5,
                vel3DMin:{x:-1, y:1, z:0},
                vel3DMax:{x:1, y:2, z:0},
                spawnDelay:18,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 10,
                serverId:8,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            18:
            {
                shipType: C_Ships.CRATE,
                size:9,
                health:200,
                qtyMin:1,
                qtyMax:1,
                movement: "2d",
                velMin: 1.5,
                velMax: 2,
                vel3DMin:{x:-1, y:1, z:0},
                vel3DMax:{x:1, y:2, z:0},
                spawnDelay:18,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 15,
                serverId:10,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            19:
            {
                shipType: C_Ships.CRATE,
                size:10,
                health:200,
                qtyMin:1,
                qtyMax:1,
                movement: "2d",
                velMin: 2,
                velMax: 3,
                vel3DMin:{x:-1, y:1, z:0},
                vel3DMax:{x:1, y:2, z:0},
                spawnDelay:18,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 20,
                serverId:12,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            20:
            {
                shipType: C_Ships.CRATE,
                size:11,
                health:200,
                qtyMin:1,
                qtyMax:1,
                movement: "2d",
                velMin: 1.5,
                velMax: 2.5,
                vel3DMin:{x:-1, y:1, z:0},
                vel3DMax:{x:1, y:2, z:0},
                spawnDelay:18,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 25,
                serverId:14,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            21:
            {
                shipType: C_Ships.POD,
                size:8,
                health:200,
                qtyMin:1,
                qtyMax:1,
                movement: "2d",
                velMin: 2.5,
                velMax: 3.5,
                vel3DMin:{x:-1, y:2, z:0},
                vel3DMax:{x:1, y:3, z:0},
                spawnDelay:15,
                multiplierChance: 0.01,
                rotation:-Math.PI,
                shootChance:0,
                prize: 60,
                serverId:13,
                permanentRotation:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, -100, Number.NEGATIVE_INFINITY),
                posMax:new Point3D(Number.POSITIVE_INFINITY, 100, Number.POSITIVE_INFINITY),
            },

            22:
            {
                shipType: C_Ships.MOTHER_OF_THE_MOONS,
                // size:83,
                size:45,
                health:200,
                qtyMin:1,
                qtyMax:1,
                movement: "3d",
                // vel3DMin:{x:2.6, y:-1.4, z:15},
                // vel3DMax:{x:2.6, y:-1.4, z:15},
                // vel3DMin:{x:0, y:0, z:0},
                // vel3DMax:{x:0, y:0, z:0},
                vel3DMin:{x:0, y:0, z:15},
                vel3DMax:{x:0, y:0, z:15},
                directionDelay: 12,
                directionExtraDelay: 20,
                spawnDelay:10,
                prize: 80,
                serverId:10,
                shootChance:1,
                // shootOrigins:[{x:-13, y:-35}, {x:0, y:0}, {x:13, y:24}, {x:16, y:-28}, {x:-16, y:32}],
                // shootOrigins:[{x:2, y:8}, {x:-30, y:-30}, {x:37, y:-4}],
                shootOrigins:[{x:-35, y:-30}, {x:35, y:-33}, {x:-33, y:-20},
                    {x:33, y:-20}, {x:-33, y:-6}, {x:34, y:-6.5}],
                shootDelay: 8,
                shootExtraDelay: 12,
                canReturn:true,
                // overlay:true,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, 1250),
            }
        };

        this.topShips =
        {
            1:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:7,
                health:20,
                qtyMin:2,
                qtyMax:5,
                movement: "2d",
                velMin: 6,
                velMax: 7,
                vel3DMin:{x:0, y:0, z:40},
                vel3DMax:{x:0, y:0, z:100},
                spawnDelay:2,
                multiplierChance: 0.01,
                shootChance:.1,
                shootOrigins:[{x:-44, y:30}, {x:44, y:30}],
                shootDelay: 0,
                prize: 20,
                serverId:4,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            2:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:10,
                health:40,
                qtyMin:2,
                qtyMax:4,
                velMin: 5.5,
                velMax: 6,
                movement: "2d",
                vel3DMin:{x:0, y:0, z:30},
                vel3DMax:{x:0, y:0, z:40},
                spawnDelay:3,
                multiplierChance: 0.01,
                shootChance:.2,
                shootOrigins:[{x:0, y:22}],
                shootDelay: 0,
                prize: 25,
                serverId:7,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            3:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:12,
                health:200,
                qtyMin:2,
                qtyMax:3,
                movement: "2d",
                velMin: 3.5,
                velMax: 3.5,
                vel3DMin:{x:0, y:0, z:20},
                vel3DMax:{x:0, y:0, z:30},
                spawnDelay:4,
                multiplierChance: 0.01,
                shootChance:.3,
                shootOrigins:[{x:0, y:-45}],
                shootDelay: 0,
                prize: 30,
                serverId:10,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            4:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:16,
                health:500,
                qtyMin:1,
                qtyMax:2,
                movement: "2d",
                velMin: 2.5,
                velMax: 3,
                vel3DMin:{x:0, y:0, z:10},
                vel3DMax:{x:0, y:0, z:20},
                spawnDelay:5,
                multiplierChance: 0.01,
                shootChance:.4,
                shootOrigins:[{x:-38, y:41},{x:-26, y:41},{x:26, y:41},{x:38, y:41}],
                shootDelay: 0,
                prize: 40,
                serverId:11,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },
        };

        this.normalShips =
        {
            1:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:13, // 6
                health:20,
                qtyMin:2, // 2
                qtyMax:5, // 5
                animation: true,
                endFrame: 9,
                animationHeight: 150,
                animAnchor: {x: 0.5, y: 0.53},
                movement: "3d",
                // vel3DMin:{x:0, y:0, z:40},
                // vel3DMax:{x:0, y:0, z:100},
                vel3DMin:{x:0, y:0, z:30},
                vel3DMax:{x:0, y:0, z:40},
                spawnDelay:2,
                multiplierChance: 0.01,
                shootChance:.1,
                shootOrigins:[{x:-44, y:30}, {x:44, y:30}],
                shootDelay: 0,
                prize: 20,
                serverId:4,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            2:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:15, // 8
                health:40,
                qtyMin:1, // 1
                qtyMax:4, // 4
                animation: true,
                endFrame: 9,
                animationHeight: 110,
                animAnchor: {x: 0.5, y: 0.5},
                movement: "3d",
                // vel3DMin:{x:0, y:0, z:30},
                // vel3DMax:{x:0, y:0, z:40},
                vel3DMin:{x:0, y:0, z:25},
                vel3DMax:{x:0, y:0, z:30},
                spawnDelay:3,
                multiplierChance: 0.01,
                shootChance:.2,
                shootOrigins:[{x:0, y:22}],
                shootDelay: 0,
                prize: 25,
                serverId:7,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            3:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:17, // 10
                health:200,
                qtyMin:1, // 1
                qtyMax:2, // 2
                animation: true,
                endFrame: 9,
                animationHeight: 120,
                animAnchor: {x: 0.5, y: 0.57},
                movement: "3d",
                // vel3DMin:{x:0, y:0, z:20},
                // vel3DMax:{x:0, y:0, z:30},
                vel3DMin:{x:0, y:0, z:20},
                vel3DMax:{x:0, y:0, z:25},
                spawnDelay:4,
                multiplierChance: 0.01,
                shootChance:.3,
                shootOrigins:[{x:0, y:-45}],
                shootDelay: 0,
                prize: 30,
                serverId:10,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },

            4:
            {
                shipType: C_Ships.ENEMY_SHIP,
                size:24, // 15
                health:500,
                qtyMin:1, // 1
                qtyMax:1, // 1
                animation: true,
                endFrame: 9,
                animationHeight: 110,
                animAnchor: {x: 0.5, y: 0.55},
                movement: "3d",
                vel3DMin:{x:0, y:0, z:10},
                vel3DMax:{x:0, y:0, z:20},
                spawnDelay:5,
                multiplierChance: 0.01,
                shootChance:.4,
                shootOrigins:[{x:-38, y:41},{x:-26, y:41},{x:26, y:41},{x:38, y:41}],
                shootDelay: 0,
                prize: 40,
                serverId:11,
                posMin:new Point3D(Number.NEGATIVE_INFINITY, Number.NEGATIVE_INFINITY, 0),
                posMax:new Point3D(Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY, Number.POSITIVE_INFINITY),
            },
        }
    }





}

export default (new FlierData);